__turbopack_context__.v({
  "caption": "VXfsGa_caption",
  "card": "VXfsGa_card",
  "cardContent": "VXfsGa_cardContent",
  "controls": "VXfsGa_controls",
  "exhibit": "VXfsGa_exhibit",
  "play": "VXfsGa_play",
  "shellPrompt": "VXfsGa_shellPrompt",
  "stack": "VXfsGa_stack",
  "terminal": "VXfsGa_terminal",
  "terminalDots": "VXfsGa_terminalDots",
  "terminalLabel": "VXfsGa_terminalLabel",
  "terminalNote": "VXfsGa_terminalNote",
  "terminalRecords": "VXfsGa_terminalRecords",
});
